import React from 'react';
import classes from './Backdrop.css'

const Backdrop = (props) => (
        props.show ? <div className={classes.Backdrop} onClick={props.clicked}></div> : null
    );

export default Backdrop;




// WEBPACK FOOTER //
// ./src/components/Layout/UI/Backdrop/Backdrop.js